// extracted by mini-css-extract-plugin
module.exports = {"width":"VerificationQR_width__3K425","text":"VerificationQR_text__1UQg7","error__qr":"VerificationQR_error__qr__10yQX","refreshIcon":"VerificationQR_refreshIcon__4M7Nt"};